import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LoadingState } from '../components/molecules/FeedbackState';
import { useAppSelector } from '../hooks/redux';

export function ProtectedRoute() {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAppSelector((state) => state.auth);

  if (isLoading) return <LoadingState label="Restoring your session…" />;
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}
